<pop-tree-cell-dropdown></pop-tree-cell-dropdown>

<div class="custom-treetable pop-treetable estimate-tree-table"
     [class.loading]="!isLoaded"
     #treeTableParent>
  <p-treeTable class="pop-treetable"
               [value]="estimateTree"
               *ngIf="isLoaded; else loadingTemplate"
               frozenWidth="13em"
               [virtualScrollItemSize]="32"
               [scrollHeight]="scrollBodyHeight"
               [scrollable]="true"
               [totalRecords]="totalRecords"
               (onEditComplete)="onEditComplete($event)"
               (onNodeExpand)="nodeExpand($event)"
               (onNodeCollapse)="nodeCollapse($event)">
    <ng-template pTemplate="frozencolgroup"
                 let-columns>
      <colgroup>
        <col style="width: 11em" />
        <col style="width: 2em"
             *ngIf="!sectionFilters.hideSectionNotes" />
      </colgroup>
    </ng-template>
    <ng-template pTemplate="colgroup"
                 let-columns>
      <colgroup>
        <col style="width: 2.75em"
             *ngIf="!sectionFilters.hideSectionDates && !areDatesHidden" />
        <col style="width: 2.75em"
             *ngIf="!sectionFilters.hideSectionDates && !areDatesHidden" />

        <col *ngFor="let col of feesColumns"
             [style.width]="col"
             class="fee-col" />
        <col *ngFor="let col of internalFeesColumns"
             [style.width]="col"
             class="fee-col" />
        <col *ngFor="let col of expenseColumns"
             [style.width]="col"
             class="exp-col" />
        <col *ngFor="let col of totalColumns"
             [style.width]="col"
             class="tot-col" />
      </colgroup>
    </ng-template>
    <!-- TABLE HEADERS -->
    <ng-template pTemplate="frozenheader"
                 let-columns>
      <tr>
        <th class="project-top-header"
            [attr.colspan]="sectionFilters.hideSectionNotes ? 1 : 3"
            style="text-align: left !important">
          <i class="far fa-expand-alt"
             (click)="expandAll()"
             *ngIf="isCollapsed"
             [matTooltip]="'TOOLTIP.EXPAND' | translate"
             matTooltipClass="pop-tooltip"
             position="below"></i>
          <i class="far fa-compress-alt"
             (click)="collapseAll()"
             *ngIf="isExpanded"
             [matTooltip]="'TOOLTIP.COLLAPSE' | translate"
             matTooltipClass="pop-tooltip"
             position="below"></i>
          <pop-column-toggle iconClassCollapsed="fa-calendar-plus"
                             [(isCollapsed)]="areDatesHidden"
                             (isCollapsedChange)="refreshDateColspan()"
                             *ngIf="!sectionFilters.hideSectionDates && areDatesHidden"
                             [tooltipCollapsed]="'TOOLTIP.SEE_DATES' | translate">
          </pop-column-toggle>
        </th>
      </tr>
      <tr>
        <th class="pro-header"
            rowspan="2"
            translate="TABLE.PROJECT"></th>
        <th *ngIf="!sectionFilters.hideSectionNotes"
            class="note-header pop-border-left"
            translate="TABLE.NOTE"
            rowspan="2"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="header"
                 let-columns>
      <!-- TOP HEADERS -->
      <tr>
        <th class="date-top-header"
            [attr.colspan]="dateColspan"
            *ngIf="!sectionFilters.hideSectionDates && !areDatesHidden">
          <pop-column-toggle iconClassExpanded="fa-calendar-minus"
                             [(isCollapsed)]="areDatesHidden"
                             (isCollapsedChange)="refreshDateColspan()"
                             [tooltipExpanded]="'TOOLTIP.HIDE_DATES' | translate">
            {{ 'HEADER.DATES' | translate }}
          </pop-column-toggle>
        </th>
        <th class="hours-top-header"
            *ngIf="!sectionFilters.hideSectionFees"
            [attr.colspan]="feesColumns.length">
          <pop-column-toggle [(isCollapsed)]="isClassColumnsCollapsed"
                             (isCollapsedChange)="scheduledReInitTreeTable()"
                             [isEnabled]="currentEstimate?.classificationEstimates && currentEstimate.classificationEstimates.length > 0"
                             [tooltipCollapsed]="'TOOLTIP.SEE_CLASS' | translate"
                             [tooltipExpanded]="'TOOLTIP.HIDE_CLASS' | translate">
            {{ 'HEADER.FEES' | translate }}
          </pop-column-toggle>
        </th>
        <th class="hours-top-header internal-fees-top-header"
            *ngIf="!sectionFilters.hideSectionInternalFees"
            [attr.colspan]="internalFeesColumns.length">
          <pop-column-toggle [(isCollapsed)]="isInternalResourceColumnsCollapsed"
                             (isCollapsedChange)="scheduledReInitTreeTable()"
                             [isEnabled]="currentEstimate?.internalResourceEstimates?.length > 0"
                             [tooltipCollapsed]="'TOOLTIP.SEE_CLASS' | translate"
                             [tooltipExpanded]="'TOOLTIP.HIDE_CLASS' | translate">
            {{ 'HEADER.INTERNAL_FEES' | translate }}
          </pop-column-toggle>
        </th>
        <th class="expense-top-header"
            *ngIf="!sectionFilters.hideSectionExpenses"
            [attr.colspan]="expenseColumns.length">
          <pop-column-toggle [(isCollapsed)]="isExpenseColumnCollapsed"
                             (isCollapsedChange)="scheduledReInitTreeTable()"
                             [tooltipCollapsed]="'TOOLTIP.SEE_EXPENSE' | translate"
                             [tooltipExpanded]="'TOOLTIP.HIDE_EXPENSE' | translate">
            {{ 'HEADER.EXPENSE' | translate }}
          </pop-column-toggle>
        </th>
        <th class="total-top-header"
            [attr.colspan]="totalColumns.length"
            translate="HEADER.TOTALS"></th>
      </tr>
      <!-- SUB HEADERS -->
      <tr>
        <!-- Dates -->
        <ng-container *ngIf="!sectionFilters.hideSectionDates">
          <th class="date-s-header"
              *ngIf="!areDatesHidden"
              translate="TABLE.START"></th>
          <th class="date-e-header pop-border-right"
              translate="TABLE.END"
              *ngIf="!areDatesHidden"></th>
        </ng-container>

        <!-- Hours -->
        <ng-container *ngIf="!sectionFilters.hideSectionFees">
          <th class="class-header"
              [hidden]="isClassColumnsCollapsed"
              *ngFor="
            let classificationEstimate of classificationEstimates
          "
              matTooltip="{{
            classificationEstimate.classification
              | classDescription: currentLang
          }}"
              matTooltipClass="pop-tooltip"
              position="above">
            <div class="sub-header-container">
              <span [hidden]="
                classificationEstimate?.classification?.code.toUpperCase() ===
                  '#TOUS' ||
                classificationEstimate?.classification?.code.toUpperCase() ===
                  '#ALL'
              ">{{ classificationEstimate?.classification?.code }}</span>
              <span>
                {{
                classificationEstimate.classification
                | classDescription: currentLang
                }}
              </span>
            </div>
          </th>
          <th class="hours-header"
              translate="HEADER.HOURS"></th>
          <th class="total-cost-header">
            {{ "TABLE.COSTING" | translate }} ({{ functionalCurrencySymbol }})
          </th>
          <th class="total-s-header">
            {{ "TABLE.SELLING" | translate }} ({{ functionalCurrencySymbol }})
          </th>
          <th class="total-s-header currency-header"
              *ngIf="!isEstimateOnFunctionalCurrency">
            {{ "TABLE.SELLING" | translate }} ({{ currencySymbol }})
          </th>
          <th class="final-selling-header"
              *ngIf="isEstimateOnFunctionalCurrency">
            {{ "TABLE.TOTAL_SELLING" | translate }} ({{ functionalCurrencySymbol }})
          </th>
          <th class="total-s-header currency-header"
              *ngIf="!isEstimateOnFunctionalCurrency">
            {{ "TABLE.TOTAL_SELLING" | translate }} ({{ currencySymbol }})
          </th>
          <th class="final-selling-header currency-header"
              *ngIf="!isEstimateOnFunctionalCurrency">
            {{ "TABLE.FUNCTIONAL" | translate }} ({{ functionalCurrencySymbol }})
          </th>
        </ng-container>

        <!-- Internal Fees-->
        <ng-container *ngIf="!sectionFilters.hideSectionInternalFees">
          <th class="internal-resource-header"
              [hidden]="isInternalResourceColumnsCollapsed"
              *ngFor="let internalResourceEstimate of internalResourceEstimates"
              matTooltip="{{ internalResourceEstimate.internalResource?.description }}"
              matTooltipClass="pop-tooltip"
              position="above">
            <div class="sub-header-container">
              <span>{{ internalResourceEstimate?.internalResource?.code }}</span>
              <span>
                {{ internalResourceEstimate.internalResource?.description }}
              </span>
            </div>
          </th>

          <th class="quantity-header"
              [class.pop-border-left]="isInternalResourceColumnsCollapsed"
              translate="HEADER.QUANTITY"></th>
          <th class="total-cost-header">
            {{ "TABLE.COSTING" | translate }} ({{ functionalCurrencySymbol }})
          </th>
          <th class="total-s-header">
            {{ "TABLE.SELLING" | translate }} ({{ functionalCurrencySymbol }})
          </th>
          <th class="total-s-header currency-header"
              *ngIf="!isEstimateOnFunctionalCurrency">
            {{ "TABLE.SELLING" | translate }} ({{ currencySymbol }})
          </th>
          <th class="final-selling-header"
              *ngIf="isEstimateOnFunctionalCurrency">
            {{ "TABLE.TOTAL_SELLING" | translate }} ({{ functionalCurrencySymbol }})
          </th>
          <th class="total-s-header currency-header"
              *ngIf="!isEstimateOnFunctionalCurrency">
            {{ "TABLE.TOTAL_SELLING" | translate }} ({{ currencySymbol }})
          </th>
          <th class="final-selling-header currency-header"
              *ngIf="!isEstimateOnFunctionalCurrency">
            {{ "TABLE.FUNCTIONAL" | translate }} ({{ functionalCurrencySymbol }})
          </th>
        </ng-container>

        <!-- Expenses -->
        <ng-container *ngIf="!sectionFilters.hideSectionExpenses">
          <th class="table-sub-header pop-border-left"
              *ngIf="!isExpenseColumnCollapsed"
              translate="TABLE.EXP_QUANTITY"></th>
          <th class="table-sub-header"
              *ngIf="!isExpenseColumnCollapsed">
            {{ "TABLE.EXP_UNITCOST" | translate }} ({{ functionalCurrencySymbol }})
          </th>
          <th class="table-sub-header"
              [class.pop-border-left]="isExpenseColumnCollapsed">
            {{ "TABLE.COSTING" | translate }} ({{ functionalCurrencySymbol }})
          </th>
          <th class="selling-header">
            {{ "TABLE.SELLING" | translate }} ({{ functionalCurrencySymbol }})
          </th>
          <th class="selling-header currency-header"
              *ngIf="!isEstimateOnFunctionalCurrency">
            {{ "TABLE.SELLING" | translate }} ({{ currencySymbol }})
          </th>
          <th class="final-selling-header"
              *ngIf="isEstimateOnFunctionalCurrency">
            {{ "TABLE.TOTAL_SELLING" | translate }} ({{ functionalCurrencySymbol }})
          </th>
          <th class="final-selling-header currency-header"
              *ngIf="!isEstimateOnFunctionalCurrency">
            {{ "TABLE.TOTAL_SELLING" | translate }} ({{ currencySymbol }})
          </th>
          <th class="final-selling-header currency-header"
              *ngIf="!isEstimateOnFunctionalCurrency">
            {{ "TABLE.FUNCTIONAL" | translate }} ({{ functionalCurrencySymbol }})
          </th>
          <th *ngIf="isTableEditable"
              class="table-sub-header">
          </th>
        </ng-container>

        <!-- Totals -->
        <ng-container *ngIf="!sectionFilters.hideSectionBudgetPercentage">
          <th class="costing-header pop-text-align-center pop-border-left">
            {{ "TABLE.COSTING" | translate }} (%)
          </th>
        </ng-container>
        <th class="costing-header pop-text-align-center">
          {{ "TABLE.COSTING" | translate }} ({{ functionalCurrencySymbol }})
        </th>
        <th class="selling-header">
          {{ "TABLE.SELLING" | translate }} ({{ functionalCurrencySymbol }})
        </th>
        <th class="final-selling-header currency-header"
            *ngIf="!isEstimateOnFunctionalCurrency">
          {{ "TABLE.SELLING" | translate }} ({{ currencySymbol }})
        </th>
        <ng-container *ngIf="!sectionFilters.hideSectionBudgetPercentage">
          <th class="final-selling-header"
              [class.currency-header]="!isEstimateOnFunctionalCurrency">
            {{ "TABLE.TOTAL_SELLING" | translate }} (%)
          </th>
        </ng-container>
        <th class="final-selling-header"
            *ngIf="isEstimateOnFunctionalCurrency">
          {{ "TABLE.TOTAL_SELLING" | translate }} ({{ functionalCurrencySymbol }})
        </th>
        <th class="final-selling-header currency-header"
            *ngIf="!isEstimateOnFunctionalCurrency">
          {{ "TABLE.TOTAL_SELLING" | translate }} ({{ currencySymbol }})
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="frozenbody"
                 let-rowData="rowData"
                 let-rowNode
                 let-columns="columns">
      <tr [ngClass]="{
          'total-row': rowData.type === 'project',
          'level1-total': rowData.type === 'level1',
          'level2-total': rowData.type === 'level2',
          'department-total':
            currentEstimate.budgetType === 'Detailed' &&
            rowData.type === 'department'
        }">
        <td class="project-col"
            [ngStyle]="{
        'font-weight':
          rowData.type === lowestTimeLevel ||
          rowData.type === lowestExpenseLevel
            ? '400'
            : '500'
      }">
          <pop-estimate-tree-cell [rowNode]="rowNode"
                                  [currentEstimate]="currentEstimate"
                                  [isLineBusy]="isEstimateLineBusy(rowNode.node)"></pop-estimate-tree-cell>
        </td>

        <ng-container *ngIf="!sectionFilters.hideSectionNotes">
          <td class="note-col">
            <i class="fas fa-ellipsis-h"
               (click)="toggleNoteDialog($event, rowData, op)"></i>
            <div class="comment-indicator-container"
                 *ngIf="hasNotes(rowData)">
              <div class="comment-indicator"></div>
            </div>
          </td>
        </ng-container>
      </tr>

    </ng-template>
    <ng-template pTemplate="body"
                 let-rowData="rowData"
                 let-rowNode
                 let-columns="columns">
      <tr [class.read-only]="!isTableEditable"
          [class.total-row]="rowData.type === 'project'"
          [class.level1-total]="rowData.type === 'level1'"
          [class.level2-total]="rowData.type === 'level2'"
          [class.department-total]="currentEstimate?.budgetType === 'Detailed' && rowData.type === 'department'">
        <ng-container *ngIf="!sectionFilters.hideSectionDates">
          <td class="date-s-col"
              *ngIf="!areDatesHidden"
              [class.read-only]="!isTableEditable || isStartDateDisabled(rowData)">


            <pop-date-picker-input [date]="getDateStart(rowData)"
                                   (dateChange)="setDateStart(rowData, $event)"
                                   [hideIcon]="true"
                                   [openOnClick]="true"
                                   [minDate]="getMinStartDate(rowData)"
                                   [maxDate]="getDateEnd(rowData)"
                                   [isDisabled]="!isTableEditable || isStartDateDisabled(rowData)">

            </pop-date-picker-input>
          </td>
          <td class="date-e-col"
              *ngIf="!areDatesHidden"
              [class.read-only]="!isTableEditable">

            <pop-date-picker-input [date]="getDateEnd(rowData)"
                                   (dateChange)="setDateEnd(rowData, $event)"
                                   [hideIcon]="true"
                                   [openOnClick]="true"
                                   [minDate]="getDateStart(rowData)"
                                   [maxDate]="getMaxEndDate(rowData)"
                                   [isDisabled]="!isTableEditable">

            </pop-date-picker-input>
          </td>
        </ng-container>

        <!--Classes columns-->
        <ng-container *ngIf="!sectionFilters.hideSectionFees">
          <td class="class-col"
              name="class-col"
              [hidden]="isClassColumnsCollapsed"
              *ngFor="
            let classificationEstimate of classificationEstimates
          "
              ttEditableColumn
              [ttEditableColumn]="classificationEstimate"
              [ttEditableColumnField]="rowNode"
              [ttEditableColumnDisabled]="!isTableEditable || rowData.type !== lowestTimeLevel"
              [ngClass]="
            classReadOnlyRules(rowData, classificationEstimate)
              ? removeZeroTime(rowData)
              : 'editable-cell'
          "
              [ngStyle]="{
            'font-weight': rowData.type === lowestTimeLevel ? '400' : '600'
          }"
              [matTooltip]="getClassesTooltips(rowData, classificationEstimate)"
              matTooltipClass="pop-tooltip"
              position="below">
            <div class="pop-display-flex">
              <i class="fas fa-spinner fa-spin"
                 *ngIf="isBusy[rowNode.node.data.entity.id + classificationEstimate.id]"></i>
              <p-treeTableCellEditor class="pop-flex">
                <ng-template pTemplate="input"
                             *ngIf="!classReadOnlyRules(rowData, classificationEstimate)">
                  <div class="pop-display-flex">
                    <i class="fas fa-trash"
                       (click)="removeHours(rowNode.node, classificationEstimate)"
                       *ngIf="isTableEditable
                              && rowData.totals.classificationTotals[classificationEstimate.id] !== null
                              && !isBusy[rowNode.node.data.entity.id + classificationEstimate.id]
                              && !!getClassificationLine(rowNode.node.data, classificationEstimate)"
                       [matTooltip]="'TOOLTIP.DELETE.HOURS' | translate"
                       matTooltipClass="pop-tooltip"></i>
                    <input pInputText
                           id="num-box"
                           class="money-input"
                           type="number"
                           placeholder="-"
                           [readonly]="isBusy[rowNode.node.data.entity.id + classificationEstimate.id]"
                           [(ngModel)]="rowData.totals.classificationTotals[classificationEstimate.id]"
                           name="classLineHours"
                           [ngClass]="
                            classReadOnlyRules(rowData, classificationEstimate)
                              ? removeZeroTime(rowData)
                              : 'editable-cell'
                          "
                           (focus)="selectNumbox(rowData)"
                           (blur)="editHours(rowNode.node, classificationEstimate)"
                           [ngStyle]="{ width: '90%' }" />
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  {{
                  rowData.totals.classificationTotals[classificationEstimate.id] !== null ?
                  (rowData.totals.classificationTotals[classificationEstimate.id]
                  | number: "1.0-2")
                  : "-"
                  }}
                </ng-template>
              </p-treeTableCellEditor>
              <i class="far fa-exclamation-triangle allclasswarning"
                 *ngIf="(classificationEstimate?.classification?.code.toUpperCase() === '#TOUS'
                      || classificationEstimate?.classification?.code.toUpperCase() === '#ALL')
                      && rowData.entity.structure?.level2IsUsingLaborBillingMethod
                      && rowData.totals.classificationTotals[classificationEstimate.id]"
                 [matTooltip]="'TOOLTIP.ALLCLASS_INCOMPATIBLE_LABOR_BILLING_METHOD' | translate"
                 matTooltipClass="pop-tooltip"
                 position="below"></i>
            </div>
          </td>
          <td class="hours-col">
            {{ rowData.totals.totalHours | number: "1.0-2" }}
          </td>
          <td class="hours-cost-col">
            {{ rowData.totals.totalHoursCost | number: "1.2-2" }}
          </td>
          <td class="hours-selling-col">
            {{ rowData.totals.totalHoursBillable | number: "1.2-2" }}
          </td>
          <td class="hours-selling-col"
              *ngIf="!isEstimateOnFunctionalCurrency">
            {{ rowData.totals.totalHoursBillableCurrency | number: "1.2-2" }}
          </td>
          <td class="hours-selling-col"
              [class.pop-border-right]="isEstimateOnFunctionalCurrency"
              ttEditableColumn
              [ttEditableColumn]="'hoursBillableFinal'"
              [ttEditableColumnField]="rowNode"
              [ttEditableColumnDisabled]="!isTableEditable || rowData.type !== lowestTimeLevel || (hasPC && !anyClassLineHasHours(rowData))"
              [ngClass]="hoursInputRules(rowData) ? removeZeroTime(rowData) : 'editable-cell'"
              [class.hoverable-col]="!hasPC || anyClassLineHasHours(rowData)"
              [class.pop-disabled-cell]="rowData.type === lowestTimeLevel && (hasPC && !anyClassLineHasHours(rowData))"
              [matTooltip]="getHoursTooltips(rowData)"
              matTooltipClass="pop-tooltip"
              [ngStyle]="{
            'font-weight':
              rowData.type === lowestTimeLevel ||
              rowData.type === lowestExpenseLevel
                ? '400'
                : '600'
          }">
            <div *ngIf="rowData.type === lowestTimeLevel || rowData.type === lowestExpenseLevel">
              <p-treeTableCellEditor>
                <ng-template pTemplate="input"
                             *ngIf="!hoursInputRules(rowData)">
                  <div class="pop-display-flex">
                    <i class="far fa-times"
                       (click)="clearHoursFinalValue(rowNode.node)"></i>
                    <input pInputText
                           id="hoursBillableFinal"
                           class="money-input form-control"
                           type="number"
                           placeholder="0"
                           [(ngModel)]="rowData.totals.totalHoursBillableFinal"
                           name="hoursBillableFinal"
                           (focus)="selectHoursBillableFinal()"
                           (blur)="editHoursBillableFinal(rowNode.node)"
                           [ngStyle]="{ width: '85%' }" />
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="edited-indicator-container"
                       [ngStyle]="{
                    display: hoursInputRules(rowData) ? 'none' : 'initial'
                  }"
                       *ngIf="rowData.entity.laborBillableFinal !== null">
                    <div class="edited-indicator"></div>
                  </div>
                  {{ rowData.totals.totalHoursBillableFinal | number: "1.2-2" }}
                </ng-template>
              </p-treeTableCellEditor>
            </div>
            <div *ngIf="
              rowData.type !== lowestTimeLevel &&
              rowData.type !== lowestInternalFeeLevel &&
              rowData.type !== lowestExpenseLevel
            ">
              {{ rowData.totals.totalHoursBillableFinal | number: "1.2-2" }}
            </div>
          </td>

          <td class="hours-selling-col pop-border-right"
              *ngIf="!isEstimateOnFunctionalCurrency">
            {{ rowData.totals.totalHoursBillableFinalFunctionalCurrency | number: "1.2-2" }}
          </td>
        </ng-container>

        <!--Internal Fee Columns-->
        <ng-container *ngIf="!sectionFilters.hideSectionInternalFees">
          <td class="internal-resource-col"
              name="class-col"
              [hidden]="isInternalResourceColumnsCollapsed"
              *ngFor="let internalResourceEstimate of internalResourceEstimates"
              [ttEditableColumn]="internalResourceEstimate"
              [ttEditableColumnField]="rowNode"
              [ttEditableColumnDisabled]="!isTableEditable || rowData.type !== lowestInternalFeeLevel"
              [ngClass]="
              intResourcesReadOnlyRules(rowData)
              ? removeZeroTime(rowData)
              : 'editable-cell'"
              [ngStyle]="{ 'font-weight': rowData.type === lowestInternalFeeLevel ? '400' : '600' }"
              [matTooltip]="getInternalResourcesTooltips(rowData, internalResourceEstimate)"
              matTooltipClass="pop-tooltip"
              position="below">
            <div class="pop-display-flex">
              <i class="fas fa-spinner fa-spin"
                 *ngIf="isBusy[rowNode.node.data.entity.id + internalResourceEstimate.id]"></i>
              <p-treeTableCellEditor class="pop-flex">
                <ng-template pTemplate="input"
                             *ngIf="!intResourcesReadOnlyRules(rowData)">
                  <div class="pop-display-flex">
                    <i class="fas fa-trash"
                       (click)="removeInternalResourceQuantity(rowNode.node, internalResourceEstimate)"
                       *ngIf="isTableEditable
                       && rowData.totals.internalResourceTotals[internalResourceEstimate.id] !== null
                       && !isBusy[rowNode.node.data.entity.id + internalResourceEstimate.id]
                       && !!this.getInternalFeeLine(rowNode.node.data, internalResourceEstimate)"
                       [matTooltip]="'TOOLTIP.DELETE.QUANTITY' | translate"
                       matTooltipClass="pop-tooltip"></i>
                    <input pInputText
                           id="num-box"
                           class="money-input"
                           type="number"
                           placeholder="-"
                           [readonly]="isBusy[rowNode.node.data.entity.id + internalResourceEstimate.id]"
                           [(ngModel)]="rowData.totals.internalResourceTotals[internalResourceEstimate.id]"
                           [ngClass]="
                          intResourcesReadOnlyRules(rowData)
                          ? removeZeroInternalFees(rowData)
                          : 'editable-cell'
                          "
                           (focus)="selectNumbox(rowData)"
                           (blur)="editInternalResourceQuantity(rowNode.node, internalResourceEstimate)"
                           [ngStyle]="{ width: '90%' }" />
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  {{
                  rowData.totals.internalResourceTotals[internalResourceEstimate.id] !== null ?
                  (rowData.totals.internalResourceTotals[internalResourceEstimate.id]
                  | number: "1.0-2")
                  : "-"
                  }}
                </ng-template>
              </p-treeTableCellEditor>
            </div>
          </td>
          <td class="internal-fees-col"
              [class.pop-border-left]="isInternalResourceColumnsCollapsed">
            {{ rowData.totals.totalInternalFeesQuantity | number: "1.0-2" }}
          </td>
          <td class="internal-fees-cost-col">
            {{ rowData.totals.totalInternalFeesCost | number: "1.2-2" }}
          </td>
          <td class="internal-fees-selling-col">
            {{ rowData.totals.totalInternalFeesBillable | number: "1.2-2" }}
          </td>
          <td class="internal-fees-selling-col"
              *ngIf="!isEstimateOnFunctionalCurrency">
            {{ rowData.totals.totalInternalFeesBillableCurrency | number: "1.2-2" }}
          </td>
          <td class="internal-fees-selling-col hoverable-col"
              ttEditableColumn="internalFeesBillableFinal"
              [ttEditableColumnField]="rowNode"
              [ttEditableColumnDisabled]="!isTableEditable || rowData.type !== lowestInternalFeeLevel"
              [ngClass]="
            internalFeesInputRules(rowData) ? removeZeroInternalFees(rowData) : 'editable-cell'
          "
              [matTooltip]="getInternalFeesTooltips(rowData)"
              matTooltipClass="pop-tooltip"
              [ngStyle]="{
            'font-weight':
              rowData.type === lowestTimeLevel ||
              rowData.type === lowestInternalFeeLevel ||
              rowData.type === lowestExpenseLevel
                ? '400'
                : '600'
          }">
            <div *ngIf="
              rowData.type === lowestTimeLevel ||
              rowData.type === lowestInternalFeeLevel ||
              rowData.type === lowestExpenseLevel
            ">
              <p-treeTableCellEditor>
                <ng-template pTemplate="input"
                             *ngIf="!internalFeesInputRules(rowData)">
                  <div class="pop-display-flex">
                    <i class="far fa-times"
                       (click)="clearInternalFeesFinalValue(rowNode.node)"></i>
                    <input pInputText
                           id="internalFeesBillableFinal"
                           class="money-input form-control"
                           type="number"
                           placeholder="0"
                           [(ngModel)]="rowData.totals.totalInternalFeesBillableFinal"
                           name="internalFeesBillableFinal"
                           (focus)="selectInternalFeesBillableFinal()"
                           (blur)="editInternalFeesBillableFinal(rowNode.node)"
                           [ngStyle]="{ width: '85%' }" />
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="edited-indicator-container"
                       [ngStyle]="{
                    display: internalFeesInputRules(rowData) ? 'none' : 'initial'
                  }"
                       *ngIf="rowData.entity.internalFeeBillableFinal !== null">
                    <div class="edited-indicator"></div>
                  </div>
                  {{ rowData.totals.totalInternalFeesBillableFinal | number: "1.2-2" }}
                </ng-template>
              </p-treeTableCellEditor>
            </div>
            <div *ngIf="
              rowData.type !== lowestTimeLevel &&
              rowData.type !== lowestInternalFeeLevel &&
              rowData.type !== lowestExpenseLevel
            ">
              {{ rowData.totals.totalInternalFeesBillableFinal | number: "1.2-2" }}
            </div>
          </td>
          <td class="internal-fees-selling-col"
              *ngIf="!isEstimateOnFunctionalCurrency">
            {{ rowData.totals.totalInternalFeesBillableFinalFunctionalCurrency | number: "1.2-2" }}
          </td>
        </ng-container>

        <!-- Expenses -->
        <ng-container *ngIf="!sectionFilters.hideSectionExpenses">
          <ng-container *ngIf="!isExpenseColumnCollapsed">
            <td ttEditableColumn="expenseCostQuantity"
                [ttEditableColumnField]="rowNode"
                [ttEditableColumnDisabled]="!isTableEditable || rowData.type !== lowestExpenseLevel || isBusy[rowNode.node.data.entity.id + 'expenseLine']"
                class="pop-no-padding pop-border-left"
                [class.hoverable-col]="rowData.type === lowestExpenseLevel && !expReadOnlyRules(rowData)"
                [ngClass]="expReadOnlyRules(rowData) ? removeZeroExpense(rowData) : 'editable-cell'">
              <pop-expense-cell [rowNode]="rowNode"
                                [rowData]="rowData"
                                field="expenseCostQuantity"
                                [currentEstimate]="currentEstimate"
                                [lowestExpenseLevel]="lowestExpenseLevel"
                                [groupCostTypes]="groupCostTypes"></pop-expense-cell>
            </td>
            <td *ngIf="expReadOnlyRules(rowData) || rowData.totals.expenseMethodUnitCost === undefined; else readOnlyExpenseCostUnitCost"
                ttEditableColumn="expenseCostUnitCost"
                [ttEditableColumnField]="rowNode"
                [ttEditableColumnDisabled]="!isTableEditable || rowData.type !== lowestExpenseLevel || isBusy[rowNode.node.data.entity.id + 'expenseLine']"
                class="pop-no-padding"
                [class.hoverable-col]="rowData.type === lowestExpenseLevel && !expReadOnlyRules(rowData)"
                [ngClass]="expReadOnlyRules(rowData) ? removeZeroExpense(rowData) : 'editable-cell'">
              <pop-expense-cell [rowNode]="rowNode"
                                [rowData]="rowData"
                                field="expenseCostUnitCost"
                                [currentEstimate]="currentEstimate"
                                [lowestExpenseLevel]="lowestExpenseLevel"
                                [groupCostTypes]="groupCostTypes"></pop-expense-cell>
            </td>
            <ng-template #readOnlyExpenseCostUnitCost>
              <td class="bill-col">
                {{ rowData.totals.expenseCostUnitCost | number: "1.2-2" }}
              </td>
            </ng-template>
          </ng-container>

          <td *ngIf="expReadOnlyRules(rowData) || rowData.totals.expenseMethodUnitCost === undefined; else readOnlyTotalExpensesCost"
              class="pop-no-padding"
              ttEditableColumn="totalExpensesCost"
              [ttEditableColumnField]="rowNode"
              [class.hoverable-col]="rowData.type === lowestExpenseLevel && !expReadOnlyRules(rowData)"
              [class.pop-border-left]="isExpenseColumnCollapsed"
              [ttEditableColumnDisabled]="!isTableEditable || rowData.type !== lowestExpenseLevel || isBusy[rowNode.node.data.entity.id + 'expenseLine']"
              [ngClass]="expReadOnlyRules(rowData) ? removeZeroExpense(rowData) : 'editable-cell'">
            <pop-expense-cell [rowNode]="rowNode"
                              [rowData]="rowData"
                              field="totalExpensesCost"
                              [currentEstimate]="currentEstimate"
                              [lowestExpenseLevel]="lowestExpenseLevel"
                              [groupCostTypes]="groupCostTypes">
            </pop-expense-cell>
          </td>
          <ng-template #readOnlyTotalExpensesCost>
            <td class="bill-col"
                [class.pop-border-left]="isExpenseColumnCollapsed">
              {{ rowData.totals.totalExpensesCost ?? 0 | number: "1.2-2" }}
            </td>
          </ng-template>

          <td class="bill-col">
            {{ rowData.totals.totalExpensesBillable | number: "1.2-2" }}
          </td>

          <td class="bill-col"
              *ngIf="!isEstimateOnFunctionalCurrency">
            {{ rowData.totals.totalExpensesBillableCurrency | number: "1.2-2" }}
          </td>
          <ng-container *ngIf="!isEstimateOnFunctionalCurrency">
            <td class="final-expense-col"
                ttEditableColumn="expenseBillableFinal"
                [ttEditableColumnField]="rowNode"
                [ttEditableColumnDisabled]="!isTableEditable || rowData.type !== lowestExpenseLevel || (hasPC && !rowData.totals.totalExpensesCost)"
                [class.hoverable-col]="!hasPC || rowData.totals.totalExpensesCost"
                [class.pop-disabled-cell]="rowData.type === lowestExpenseLevel && (hasPC && !rowData.totals.totalExpensesCost)"
                [matTooltip]="getExpenseBillableTooltips(rowData, getExpensesTooltips(rowData))"
                matTooltipClass="pop-tooltip"
                [ngClass]="expReadOnlyRules(rowData) ? removeZeroExpense(rowData) : 'editable-cell'"
                [ngStyle]="{
              'font-weight':
                rowData.type === lowestTimeLevel ||
                rowData.type === lowestExpenseLevel
                  ? '400'
                  : '600'
            }">
              <div *ngIf="rowData.type === lowestTimeLevel || rowData.type === lowestExpenseLevel">
                <p-treeTableCellEditor>
                  <ng-template pTemplate="input"
                               *ngIf="!expReadOnlyRules(rowData)">
                    <div class="pop-display-flex">
                      <i class="far fa-times"
                         [ngClass]="expReadOnlyRules(rowData) ? removeZeroExpense(rowData) : ''"
                         (click)="clearExpenseFinalValue(rowNode.node)"></i>
                      <input pInputText
                             id="expensesBillableFinal"
                             name="expensesBillableFinal"
                             class="money-input form-control"
                             type="number"
                             placeholder="-"
                             [readonly]="isBusy[rowNode.node.data.entity.id + 'expenseLine']"
                             [(ngModel)]="rowData.totals.totalExpensesBillableFinal"
                             (keydown.enter)="editExpensesBillableFinal(rowNode.node)"
                             (keydown.tab)="editExpensesBillableFinal(rowNode.node)"
                             (blur)="editExpensesBillableFinal(rowNode.node)"
                             [ngClass]="expReadOnlyRules(rowData)
                              ? removeZeroExpense(rowData)
                              : ''"
                             (focus)="selectExpensesBillableFinal(rowData)"
                             [ngStyle]="{ width: '85%' }" />
                    </div>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class="edited-indicator-container"
                         [ngStyle]="{
                      display: expReadOnlyRules(rowData) ? 'none' : 'initial'
                    }"
                         *ngIf="rowData.entity.expenseLine?.billableFinal !== null">
                      <div class="edited-indicator"></div>
                    </div>
                    {{
                    rowData.totals.totalExpensesBillableFinal !== undefined ?
                    (rowData.totals.totalExpensesBillableFinal | number: "1.2-2")
                    : "-"
                    }}
                  </ng-template>
                </p-treeTableCellEditor>
              </div>
              <div *ngIf="
                rowData.type !== lowestTimeLevel &&
                rowData.type !== lowestExpenseLevel
              ">
                {{ rowData.totals.totalExpensesBillableFinal | number: "1.2-2" }}
              </div>
            </td>
          </ng-container>

          <ng-container *ngIf="isEstimateOnFunctionalCurrency">
            <td class="final-expense-col"
                [class.pop-border-right]="!isTableEditable"
                ttEditableColumn="expenseBillableFinal"
                [matTooltip]="getExpenseBillableTooltips(rowData, getExpensesTooltips(rowData))"
                matTooltipClass="pop-tooltip"
                [ttEditableColumnDisabled]="!isTableEditable || rowData.type !== lowestExpenseLevel  || (hasPC && !rowData.totals.totalExpensesCost)"
                [ttEditableColumnField]="rowNode"
                [class.hoverable-col]="!hasPC || rowData.totals.totalExpensesCost"
                [class.pop-disabled-cell]="rowData.type === lowestExpenseLevel && (hasPC && !rowData.totals.totalExpensesCost)"
                [ngClass]=" expReadOnlyRules(rowData) ? removeZeroExpense(rowData) : 'editable-cell'"
                [ngStyle]="{
              'font-weight':
                rowData.type === lowestTimeLevel ||
                rowData.type === lowestExpenseLevel
                  ? '400'
                  : '600'
            }">
              <div *ngIf="
                rowData.type === lowestTimeLevel ||
                rowData.type === lowestExpenseLevel
              ">
                <p-treeTableCellEditor>
                  <ng-template pTemplate="input"
                               *ngIf="!expReadOnlyRules(rowData)">
                    <div class="pop-display-flex">
                      <i class="far fa-times"
                         [ngClass]="expReadOnlyRules(rowData) ? removeZeroExpense(rowData) : ''"
                         (click)="clearExpenseFinalValue(rowNode.node)"></i>
                      <input pInputText
                             id="expensesBillableFinal"
                             name="expensesBillableFinal"
                             class="money-input form-control"
                             type="number"
                             placeholder="-"
                             [readonly]="isBusy[rowNode.node.data.entity.id + 'expenseLine']"
                             [(ngModel)]="rowData.totals.totalExpensesBillableFinal"
                             (keydown.enter)="editExpensesBillableFinal(rowNode.node)"
                             (keydown.tab)="editExpensesBillableFinal(rowNode.node)"
                             [ngClass]="expReadOnlyRules(rowData) ? removeZeroExpense(rowData) : ''"
                             (focus)="selectExpensesBillableFinal(rowData)"
                             [ngStyle]="{ width: '85%' }" />
                    </div>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class="edited-indicator-container"
                         [ngStyle]="{
                      display: expReadOnlyRules(rowData) ? 'none' : 'initial'
                    }"
                         *ngIf="rowData.entity.expenseLine?.billableFinal !== null">
                      <div class="edited-indicator"></div>
                    </div>
                    {{
                    rowData.totals.totalExpensesBillableFinal !== undefined ?
                    (rowData.totals.totalExpensesBillableFinal | number: "1.2-2")
                    : "-"
                    }}
                  </ng-template>
                </p-treeTableCellEditor>
              </div>
              <div *ngIf="
                rowData.type !== lowestTimeLevel &&
                rowData.type !== lowestExpenseLevel
              ">
                {{ rowData.totals.totalExpensesBillableFinal | number: "1.2-2" }}
              </div>
            </td>
          </ng-container>
          <td [class.pop-border-right]="!isTableEditable"
              class="bill-col"
              *ngIf="!isEstimateOnFunctionalCurrency">
            {{ rowData.totals.totalExpensesBillableFinalFunctionalCurrency | number: "1.2-2" }}
          </td>
          <td *ngIf="isTableEditable"
              class="pop-border-right pop-text-align-center"
              [ngClass]="expReadOnlyRules(rowData) ? removeZeroExpense(rowData) : ''">
            <i class="fas fa-spinner fa-spin"
               *ngIf="isBusy[rowNode.node.data.entity.id + 'expenseLine']"></i>
            <i class="delete-expense-icon fas fa-trash"
               *ngIf="rowData.type === lowestExpenseLevel &&
                    rowData.entity?.expenseLine && !isBusy[rowNode.node.data.entity.id + 'expenseLine']"
               (click)="removeExpenses(rowNode.node)"
               [matTooltip]="'TOOLTIP.DELETE.EXPENSES' | translate"
               matTooltipClass="pop-tooltip"></i>
          </td>
        </ng-container>

        <!-- Totals -->
        <ng-container *ngIf="!sectionFilters.hideSectionBudgetPercentage">
          <td class="total-cost-col">
            {{ isPercentHidden[rowData.type] ? '' : rowNode.node | nodeTotalPercentage: estimateTree: 'totalCost':
            estimateConfig.budgetPercentDenominator }}
          </td>
        </ng-container>
        <td class="total-cost-col">
          {{ rowData.totals.totalCost | number: "1.2-2" }}
        </td>
        <td class="total-sell-col">
          {{ rowData.totals.totalBillable | number: "1.2-2" }}
        </td>
        <td class="total-sell-col"
            *ngIf="!isEstimateOnFunctionalCurrency">
          {{ rowData.totals.totalBillableCurrency | number: "1.2-2" }}
        </td>
        <ng-container *ngIf="isEstimateOnFunctionalCurrency ; else totalCurrency">
          <ng-container *ngIf="!sectionFilters.hideSectionBudgetPercentage">
            <td class="final-selling-col">
              {{ isPercentHidden[rowData.type] ? '' : rowNode.node | nodeTotalPercentage: estimateTree:
              'totalBillableFinal':
              estimateConfig.budgetPercentDenominator }}
            </td>
          </ng-container>
          <td class="final-selling-col">
            {{ rowData.totals.totalBillableFinal | number: "1.2-2" }}
          </td>
        </ng-container>
        <ng-template #totalCurrency>
          <ng-container *ngIf="!sectionFilters.hideSectionBudgetPercentage">
            <td class="final-selling-col">
              {{ isPercentHidden[rowData.type] ? '' : rowNode.node | nodeTotalPercentage : estimateTree :
              'totalBillableFinalCurrency':
              estimateConfig.budgetPercentDenominator }}
            </td>
          </ng-container>
          <td class="final-selling-col">
            {{ rowData.totals.totalBillableFinalCurrency | number: "1.2-2" }}
          </td>
        </ng-template>
      </tr>
    </ng-template>
  </p-treeTable>
  <p-overlayPanel appendTo="body"
                  #op>
    <textarea class="note-content"
              cols="38"
              rows="5"
              [readonly]="!isTableEditable"
              [(ngModel)]="selectedNote"
              (change)="setNotes(selectedRowData)"></textarea>
  </p-overlayPanel>
</div>


<ng-template #loadingTemplate>
  <pop-loading [isInline]="true"></pop-loading>
</ng-template>
